import { $toast } from "vuetify-snackbar-toast";

export default function $handleError(error) {
  const message = error?.message || error?.error?.message || error || "Erro inesperado.";

  if (!String(message).includes("Unauthenticated")) {
    $toast.danger(message);
  }
}

export const handleErrorPlugin = (vue) => {
  vue.prototype.$handleError = $handleError;
};
